import { focusElemnt } from '../../common/helper'
import { faBullseye } from "@fortawesome/free-solid-svg-icons"

export const bookingPageTab = [
  'Method Of Packing',
  'Consignment Type',
  'Weight Charges',
  //'Luggage Cities',
  //'Marquee',
  //'Payment Mode',
  'Valuation Charge',
  'Document Charge',
  'Pickup and Dropoff Charge',
  'Booking Hamali',
  'FOC Approval',
// export const bookingPageTab = [
//   'Method Of Packing',
//   'Consignment Type',
//   'Weight Charges',
//   //'Luggage Cities',
//   //'Marquee',
//   //'Payment Mode',
//   'Valuation Charge',
//   'Document Charge',
//   'Pickup and Dropoff Charge',
//   'FOC Approval',
]
export const GeneralSettingAllTabs = [
  { name: "Booking Page", translationKey: "bookingPage", JobID: 1 },
  { name: "Delivery Page", translationKey: "deliveryPage", JobID: 2 },
  { name: "Rates Matrix", translationKey: "ratesMatrix", JobID: 3 },
  { name: "Party Master", translationKey: "partyMaster", JobID: 51 },
  { name: "Route Master", translationKey: "routeMaster", JobID: 585 },
  { name: "Auto Transaction", translationKey: "autoTransaction", JobID: 5 },
  { name: "Reports Config", translationKey: "reportsConfig", JobID: 6 },
  { name: "WayBill Format", translationKey: "waybillFormat", JobID: 593 },
  { name: "Crossing Master", translationKey: "crossingMaster", JobID: 256 },
  { name: "Expense Heads", translationKey: "expenseHeads", JobID: 47 },
  { name: "SMS Policy", translationKey: "smsPolicy", JobID: 61 },
  { name: "Whatsapp Policy", translationKey: "whatsappPolicy", JobID: 521 },

  // {name:"Other",JobID:8},
]
export const bookingPageTabs = [
  { name: "Method Of Packing", translationKey: "methodOfPacking", JobID: 209 },
  { name: "Consignment Type", translationKey: "consignmentType", JobID: 50 },
  { name: "Weight Charges", translationKey: "weightCharges", JobID: 443 },
  { name: "Valuation Charge", translationKey: "valuationCharge", JobID: 211 },
  { name: "Add City", translationKey: "addCity", JobID: 7 },
  { name: "Luggage Cities", translationKey: "luggageCities", JobID: 142 },
  // { name: "Marquee", JobID: 206 },
  { name: "Payment Mode", translationKey: "paymentMode", JobID: 511 },
  { name: "Pickup and Dropoff Cartage", translationKey: "pickupDropoffCartage", JobID: 576 },
  { name: "Document Charge", translationKey: "documentCharge", JobID: 218 },
  { name: "Pickup and Dropoff Charge", translationKey: "pickupDropoffCharge", JobID: 453 },
  // { name: "FOC Approval", translationKey: "focApproval", JobID: 294 },
  { name: "Booking Hamali", translationKey: "gsBkgHml", JobID: 545 },
]
// export const bookingPageTabIds = (index) => {
//   return {
//     id: `bookingPage-tab-${index}`,
//     'aria-controls': `bookingPage-tabpanel-${index}`,
//   }
// }
export const bookingPageTabIds = (id) => {
  return {
    id: `bookingPage-tab-${id}`,
    'aria-controls': `bookingPage-tabpanel-${id}`,
  }
}
export const macDetailTabIds = (id) => {
  return {
    id: `macDetail-tab-${id}`,
    'aria-controls': `macDetail-tabpanel-${id}`,
  }
}
export const repeatdata = [
  { id: 0, name: 'contains', headerName: 'SN' },
  { id: 1, name: 'contains', headerName: 'Company Name' },
  { id: 2, name: 'contains', headerName: 'Branch Name' },
  { id: 3, name: 'contains', headerName: 'City Name' },
  { id: 4, name: 'contains', headerName: 'State Name' },
  { id: 5, name: 'contains', headerName: 'Consignment Type' },
  { id: 6, name: 'contains', headerName: 'Payment Type' },
  { id: 7, name: 'contains', headerName: 'Modified By' },
  { id: 8, name: 'contains', headerName: 'Modified Date & Time' },
  { id: 9, name: 'contains', headerName: 'Status' },
  { id: 10, name: 'contains', headerName: 'Edit' },
]

export const consTypeMOPData = [{ value: "Yes", id: 1, translationKey: "gsYes" }, { value: "No", id: 0, translationKey: "gsNo" }]

export const deliveryTypeList = [
  { id: 0, name: 'All', translationKey: 'gsAll' },
  { id: 1, name: 'Own Branch', translationKey: 'gsOwnBr' },
  { id: 2, name: 'Franchisee', translationKey: 'gsFrn' },
]
export const bookingTypeList = [
  { id: 0, name: 'All', translationKey: 'gsAll' },
  { id: 1, name: 'Own Branch', translationKey: 'gsOwnBr' },
  { id: 2, name: 'Franchisee', translationKey: 'gsFrn' },
]
export const chargeTypeList = [
  { id: 1, name: 'Per KG', translationKey: 'gsPerKg' },
  { id: 2, name: 'Per Unit', translationKey: 'gsPerUnit' },
  { id: 3, name: 'Per LR', translationKey: 'gsPerLr' },
]
export const hamaliTypeList = [
  { id: 0, name: 'Delivery Hamali', translationKey: 'gsDelHml' },
  { id: 1, name: 'Delivery Ext. Hamali', translationKey: 'gsDelExtHml' },
]
export const bookingHamaliTypeList = [
  { id: 0, name: 'Booking Hamali', translationKey: 'gsBkgHml' },
  { id: 1, name: 'Booking Op Hamali', translationKey: 'gsBkgOpHml' },
]
export const docChargeheaderdata = [
  {
    id: 0,
    name: 'contains',
    allowSorting: false,
    dataType: 'number',
    field: 'SN',
    headerSx: { minWidth: '54px' },
    showfilter: false,
    headerName: 'SN',
    translationKey: 'gsSN',
  },
  {
    id: 1,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'ChargeTypeDesc',
    headerSx: { minWidth: '244px' },
    showfilter: true,
    headerName: 'Doc. Charge Type',
    translationKey: 'docChargeType',
  },
  {
    id: 2,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'BillingUnitDesc',
    headerSx: { minWidth: '300px' },
    showfilter: true,
    headerName: 'Consignment Unit ',
    translationKey: 'consignmentUnit',
  },
  {
    id: 3,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'PaymentType',
    headerSx: { minWidth: '171px' },
    showfilter: true,
    headerName: 'Payment Type',
    translationKey: 'gsPayType',
  },
  {
    id: 4,
    name: 'contains',
    allowSorting: true,
    dataType: 'number',
    field: 'DocumentCharge',
    headerSx: { minWidth: '160px' },
    showfilter: true,
    headerName: 'Doc. Chrg.',
    translationKey: 'docChrg',
  },
  {
    id: 5,
    name: 'contains',
    allowSorting: true,
    dataType: 'string',
    field: 'ModifiedUser',
    headerSx: { minWidth: '200px' },
    showfilter: true,
    headerName: 'Modified By',
    translationKey: 'gsModBy',
  },
  {
    id: 6,
    name: 'contains',
    allowSorting: true,
    dataType: 'time',
    field: 'ModifiedDate',
    headerSx: { minWidth: '200px' },
    showfilter: false,
    headerName: 'Modified Date & Time',
    translationKey: 'gsModDt',
  },
  {
    id: 7,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'IsActive',
    headerSx: { minWidth: '82px' },
    showfilter: false,
    headerName: 'Active',
    translationKey: 'gsActive',
  },
  {
    id: 8,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'Edit',
    headerSx: { minWidth: '54px' },
    showfilter: false,
    headerName: 'Edit',
    translationKey: 'gsEdit',
  },
]

export const handlekeyDown = (e, prevId, nextId, inputID, callFunction) => {
  if (e.key === 'Enter') {
    focusElemnt(nextId)
  } else if (e.key === 'Escape') {
    focusElemnt(prevId)
  } else if (e.key === ' ') {
    callFunction()
    // focusElemnt(inputID)
  }
}
export const documentsChargeType = [
  { id: 1, Name: 'Per LR', translationKey: 'gsPerLr' },
  { id: 2, Name: 'Per Unit', translationKey: 'gsPerUnit' },
]
export const ConsignmentUnit = [
  { id: 1, Name: 'Per kg.', translationKey: 'perKgDot' },
  { id: 2, Name: 'Per Quantity', translationKey: 'perQuantity' },
]
//Delivery Page
// export const deliveryPageTab = ['Demurrage Charges', 'Delivery Charges']
export const deliveryPageTabs = [{name:"Demurrage Charges",translationKey:"gsDemChg",JobID:318},{name:"Delivery Hamali",translationKey:"gsDelHml",JobID:340},]
export const deliveryPageTabIds = (id) => {
  return {
    id: `bookingPage-tab-${id}`,
    'aria-controls': `bookingPage-tabpanel-${id}`,
  }
}
export const bookingType = [
  { id: 0, name: 'All', translationKey: 'gsAll' },
  { id: 1, name: 'Own Bookings', translationKey: 'gsOwnBkg' },
  { id: 2, name: 'Franchisee Bookings', translationKey: 'gsFrnBkg' },
]
export const bookingType1 = [
  { id: 1, name: 'Own Bookings', translationKey: 'gsOwnBkg' },
  { id: 2, name: 'Franchisee Bookings', translationKey: 'gsFrnBkg' },
]
export const chargeType = [
  { id: 0, name: 'All', translationKey: 'gsAll' },
  { id: 1, name: 'Per LR', translationKey: 'gsPerLr' },
  { id: 2, name: 'Per Unit', translationKey: 'gsPerUnit' },
]
export const chargeType1 = [
  { id: 1, name: 'Per LR', translationKey: 'gsPerLr' },
  { id: 2, name: 'Per Unit', translationKey: 'gsPerUnit' },
]
export const fixedCharge = [
  { id: 0, name: 'No', translationKey: 'gsNo' },
  { id: 1, name: 'Yes', translationKey: 'gsYes' },
]
export const valuationTableData = [
  {
    id: 0,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'right', minWidth: '40px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'SN',
    translationKey: 'gsSN',
  },
  {
    id: 1,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '235px' },
    field: 'SN',
    showfilter: true,
    field: 'CompanyName',
    headerName: 'Company Name',
    translationKey: 'companyName',
  },
  {
    id: 2,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '235px' },
    field: 'SN',
    showfilter: true,
    field: 'BranchName',
    headerName: 'Branch Name',
    translationKey: 'branchName',
  },
  {
    id: 3,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '107px' },
    field: 'SN',
    showfilter: true,
    field: 'CityName',
    headerName: 'City Name',
    translationKey: 'cityName',
  },
  {
    id: 4,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '100px' },
    field: 'SN',
    showfilter: true,
    field: 'StateName',
    headerName: 'State Name',
    translationKey: 'stateName',
  },
  {
    id: 5,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '125px' },
    field: 'SN',
    showfilter: true,
    field: 'SubType',
    headerName: 'Consignment Type',
    translationKey: 'gsCnsType',
  },
  {
    id: 6,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '94px' },
    field: 'SN',
    showfilter: true,
    field: 'PaymentType',
    headerName: 'Payment Type',
    translationKey: 'gsPayType',
  },
  {
    id: 7,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '106px' },
    field: 'SN',
    showfilter: true,
    field: 'ModifiedUser',
    headerName: 'Modified By',
    translationKey: 'gsModBy',
  },
  {
    id: 8,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '153px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'Modified Date & Time',
    translationKey: 'gsModDt',
  },
  {
    id: 9,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '60px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'Status',
    translationKey: 'gsStatus',
  },
  {
    id: 10,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '78px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'Edit',
    translationKey: 'gsEdit',
  },
]
export const autoTransPageTab = ['Auto Branch Transfer / Branch Receive', 'Auto Receive', 'Auto Delivery']
export const autoTransPageTabs = [
  { name: "Auto Branch Transfer / Branch Receive", translationKey: "autoBrTransRecv", JobID: 481 },
  { name: "Auto Receive", translationKey: "autoReceive", JobID: 532 },
  { name: "Auto Delivery", translationKey: "autoDelivery", JobID: 533 },
]
export const autoTransPageTabIds = (index) => {
  return {
    id: `autoTransPage-tab-${index}`,
    'aria-controls': `autoTransPage-tabpanel-${index}`,
  }
}
export const satusList = [
  { id: 1, name: 'Active', translationKey: 'gsActive' },
  { id: 0, name: 'Inactive', translationKey: 'gsInactive' },
]

export const paymentModecolumn = [
  { headerName: '', dataType:"string",field: "", headerSx: { textAlign:"center",minWidth: "73px" }, showString:faBullseye,showfilter: false,allowSorting:false },
  { headerName: 'Branch Name', translationKey: 'branchName', dataType:"string",field: "BranchName", headerSx: { textAlign:"left",minWidth: "300px" }, showString:faBullseye,allowSorting:false,showfilter: true },
  { headerName: 'City Name', translationKey: 'cityName', dataType:"string",field: "CityName", headerSx: { textAlign:"left",minWidth: "100px" }, showString:faBullseye,allowSorting:false,showfilter: true },
  { headerName: 'Credit and Debit', translationKey: 'creditAndDebit', dataType:"string",field: "Credit and Debit", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'Net Banking', translationKey: 'netBanking', dataType:"string",field: "Net Banking", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'UPI Payment', translationKey: 'upiPayment', dataType:"string",field: "UPI Payment", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'Is Cheque', translationKey: 'isCheque', dataType:"string",field: "Is Cheque", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'Modified By', translationKey: 'gsModBy', dataType:"string",field: "ModifiedBy", headerSx: { textAlign:"left",minWidth: "216px" }, showString:faBullseye,allowSorting:true,showfilter: false },
  { headerName: 'Modified Date & Time', translationKey: 'gsModDt', dataType:"time",field: "ModifiedDateTime", headerSx: { textAlign:"center",minWidth: "216px" }, showString:faBullseye,allowSorting:true,showfilter: false },
]

//
export const waybillFormatPageTab = ['Standard Ticket Format', 'CUSTOMIZE Ticket Format']
export const waybillFormatPageTabIds = (index) => {
  return {
    id: `bookingPage-tab-${index}`,
    'aria-controls': `bookingPage-tabpanel-${index}`,
  }
}
export const formatTypeList = [
  { id: 0, name: 'BLANK', translationKey: 'wbBlank' },
  { id: 1, name: 'PRE-PRINTED', translationKey: 'wbPrePrinted' },
]
export const statusList = [
  { id: 1, name: 'Active', translationKey: 'gsActive' },
  { id: 0, name: 'Inactive', translationKey: 'gsInactive' },
]

//fontsize 10 to 36
export const fontSizeArray = Array.from({ length: 27 }, (_, index) => ({ id: index + 10 }))

export const imgList = [
  { id: 1, name: 'Logo', translationKey: 'wbLogo' },
  { id: 2, name: 'QR', translationKey: 'wbQr' },
]
export const ratioList = [
  { id: 1, name: '1:1' },
  { id: 2, name: '4:1' },
  { id: 3, name: '1:2' },
]
export const labelList = [
  { id: 1, name: 'LR No.', translationKey: 'wbLrNo' },
  { id: 2, name: 'From', translationKey: 'wbFrom' },
  { id: 3, name: 'To', translationKey: 'wbTo' },
  { id: 4, name: 'Quantity', translationKey: 'wbQuantity' },
]
export const getUseableArea = (containerId, margins) => {
  const container = document.getElementById(containerId)
  const width = container?.offsetWidth || 0
  const height = container?.offsetHeight || 0
  return {
    left: parseFloat(margins?.left || '0'),
    top: parseFloat(margins?.up || '0'),
    right: width - parseFloat(margins?.right || '0'),
    bottom: height - parseFloat(margins?.down || '0'),
  }
}

export const clampRectToTicket = (left, top, width, height, bounds) => {
  const itemWidth = parseFloat(width) || 0
  const itemHeight = parseFloat(height) || 0
  const nextLeft = parseFloat(left) || 0
  const nextTop = parseFloat(top) || 0
  const maxLeft = bounds.right - itemWidth
  const maxTop = bounds.bottom - itemHeight
  return {
    left: Math.max(bounds.left, Math.min(nextLeft, maxLeft)),
    top: Math.max(bounds.top, Math.min(nextTop, maxTop)),
  }
}
export const reportsPageTab = ['GST Invoice Configuration', 'Monthly Target']
export const reportsPageTabs = [
  { name: 'GST Invoice Configuration', translationKey: 'gstInvoiceConfig', JobID: 520 },
  { name: 'Monthly Target', translationKey: 'monthlyTarget', JobID: 425 },
]
export const reportsPageTabIds = (index) => {
  return {
    id: `autoTransPage-tab-${index}`,
    'aria-controls': `autoTransPage-tabpanel-${index}`,
  }
}

export const partyMasterPageTabs = [
  {name:"Party Config.",translationKey:"partyConfig",JobID:1},
  {name:"Corporate Rate Matrix",translationKey:"corporateRateMatrix",JobID:2},
  {name:"Party Rate Matrix",translationKey:"partyRateMatrix",JobID:3},
]
export const partyMasterPageTabIds = (index) => {
  return {
    id: `partyMasterPage-tab-${index}`,
    'aria-controls': `partyMasterPage-tabpanel-${index}`,
  }
}

